$(document).ready(function() {
	// base url
	if (location.hostname == 'dev.spleen-creation.be' || location.hostname == 'localhost' || location.hostname == 'localhost:8888') {
        var path = '/cefim/';
    } else {
        var path = '/';
    }

    var token = $('html').attr('token');
    var lang = $('html').attr('lang');
    var data_table_i18n = { 'fr': 'French', 'en' : 'English', 'nl' : 'Dutch'};

    toastr.options = {
		"closeButton": true,
		"debug": false,
		"newestOnTop": false,
		"progressBar": true,
		"positionClass": "toast-top-center",
		"preventDuplicates": true,
		"onclick": null,
		"showDuration": "300",
		"hideDuration": "1000",
		"timeOut": "2000",
		"extendedTimeOut": "1000",
		"showEasing": "swing",
		"hideEasing": "linear",
		"showMethod": "fadeIn",
		"hideMethod": "fadeOut"
	}

	// init datatable
	if($('body').find('.data-table').length>0) {
		//var language = $('html').attr('lang');
        $('.data-table').DataTable({
            responsive: true,
            fixedHeader: {
                header: false,
                footer: true
            },
            "language": {
                "url": "//cdn.datatables.net/plug-ins/9dcbecd42ad/i18n/"+data_table_i18n[lang]+".json"
            },
            "pageLength": 25,
            "aaSorting": []
        });

		$.fn.dataTable.moment = function ( format, locale ) {
		    var types = $.fn.dataTable.ext.type;
		 
		    // Add type detection
		    types.detect.unshift( function ( d ) {
		        return moment( d, format, locale, true ).isValid() ?
		            'moment-'+format :
		            null;
		    } );
		 
		    // Add sorting method - use an integer for the sorting
		    types.order[ 'moment-'+format+'-pre' ] = function ( d ) {
		        return moment( d, format, locale, true ).unix();
		    };
		};

		$.fn.dataTable.moment( 'DD-MM-YYYY' );
	}

	// init datepicker
	$('.datepicker').datepicker({
	    format: "dd-mm-yyyy",
	    weekStart: 1,
	    daysOfWeekDisabled: "0,6",
    	startDate: '0d'
	});

	// init selectpicker
	$('.selectpicker').selectpicker();
	$(document).on('click', '.bootstrap-select button', function(e) {
		e.preventDefault();
		return false;
	});
	
	// init flash
	if($('#modal-flash').length > 0) {
		var flash = $('#modal-flash').data('flash');

		if(localStorage.getItem('flash') === null || localStorage.getItem('flash') != flash) {			
			$('#modal-flash').modal('show');
			localStorage.clear();
		}

		$(document).on('click', '#modal-flash .btn-close', function() {
			localStorage.setItem('flash', flash);
		});

	}

	// personnalise les datas à transmettre en dehors d'un serializeArray() dans la fonction xhr_send()
	function xhr_data(file, data, $this) {
		switch(file) {
			case 'formation/search-training':
				var filter = [];
				var cat = [];
				var search = $('#search-training').val();
				var page = $('#paginations .page-item.active').attr('id');
				if (page === undefined) {
					page = 1;
				}

				$('input[data-search-cat]:checked').each(function(i) {
		            filter.push($(this).val());
		            cat.push($(this).data('search-cat'));
		            console.log($(this).val(), $(this).data('search-cat'))
		    	});
		    	console.log(filter)

		    	var range = '1;Cycle';
		    	var duree = '1;Cycle';

		    	data[data.length] = { name: 'filter[]', value: filter };
		    	data[data.length] = { name: 'cat[]', value: cat };
		    	data[data.length] = { name: 'search', value: search };
		    	data[data.length] = { name: 'page', value: page };
		    	data[data.length] = { name: 'range', value: range };
		    	data[data.length] = { name: 'duree', value: duree };
		    	break;
		    case  'formation/mdlc-subscription':
				$('#modal-mdlc-subscription [data-xhr]').html('<i class="fa-solid fa-circle-notch fa-spin"></i> Envoyer');
				$('#modal-mdlc-subscription [data-xhr]').attr('disabled', true);
		    	break;

		    case 'cart/update-cart':
		    	var id = $this.closest('[data-id]').data('id');
		    	data[data.length] = { name: 'id', value: id };
		    	break;

		    case 'cart/delete-cart':
		    	var id = $this.data('id');
		    	data[data.length] = { name: 'id', value: id };
		    	break;

		    case 'cart/check-bce' :
					$this.closest('form').find('#company, #legal-form, #street, #postal-code, #city').attr('disabled', true);
					$this.closest('form').find('#vatHelp span').addClass('d-none');
					$this.closest('form').find('#vatHelp span.loading-text').removeClass('d-none');

				break;

		    default:
		    	return true;
	    }
	}
	
	// personnalise les callback en cas de succès dans la fonction xhr_send()
	function xhr_success(callback = null, response, $this) {
		switch(callback) {
			case  'formation/subscription':
				toastr.success(response.msg);
				$('#modal-subscription').modal('hide');
				$('#modal-subscription').find('input:not([type=hidden])').val('');
				$('#modal-subscription').find('input[type=checkbox]').prop('checked', false);
		    	break;
			case  'formation/cll-subscription':
				toastr.success(response.msg);
				$('#modal-cll-subscription').modal('hide');
				$('#modal-cll-subscription').find('input:not([type=hidden])').val('');
				$('#modal-cll-subscription').find('input[type=checkbox]').prop('checked', false);
		    	break;
			case  'formation/mdlc-subscription':
				toastr.success(response.msg);
				$('#modal-mdlc-subscription').modal('hide');
				$('#modal-mdlc-subscription').find('input:not([type=hidden])').val('');
				$('#modal-mdlc-subscription').find('input[type=checkbox]').prop('checked', false);
		    	break;
			case  'contact/formation-sur-mesure':
				$('#form-formation-sur-mesure').find('input:not([type=hidden])').val('');
				$('#form-formation-sur-mesure').find('textarea').val('');
				$('#form-formation-sur-mesure').find('input[type=checkbox]').prop('checked', false);
				$('#form-formation-sur-mesure').load(path+'Connections/request/xhr/contact/formation-sur-mesure-success.php');
		    	break;
			case  'contact/contact':
				$('#form-contact').find('input:not([type=hidden])').val('');
				$('#form-contact').find('textarea').val('');
				$('#form-contact').find('input[type=checkbox]').prop('checked', false);
				$('#form-contact').load(path+'Connections/request/xhr/contact/contact-success.php');
		    	break;

		    case 'cart/delete-cart':
		    	$this.closest('.formation-recap').remove();
		    	break;
		    case 'cart/check-bce' :
					$.each(response.json_formated, function( index, value ) {
						if(index != 'token') {
							$this.closest('form').find('#'+index).val(value);
							$this.closest('form').find('#'+index).attr('disabled', false);
						}					
					});

					$this.closest('form').find('#vatHelp span').removeClass('d-none');
					$this.closest('form').find('#vatHelp span.loading-text').addClass('d-none');

				break;
					
			case 'cart/payment':
				if (response.pay_type == "bancontact") {
					location.href = response.return_url;
				}
				else if(response.pay_type == "credit_card"){

					if (response.action == 'success') {
						console.log(response.return_url);
						console.log(response.client_secret);

						var clientSecret = response.client_secret;

						stripe.confirmCardPayment(clientSecret, {
							payment_method: {
								card: cardNumber,
								billing_details: {
									name: response.name,
								}
							}
						})
						.then(function(result) {
							console.log(result);
							if (result.error) {
								$('.alert').addClass('alert-danger').html('<i class="fa fa-times me-3"></i>'+result.error.message).show();
								$('#loader').hide();
							}
							else if (result.paymentIntent.status == "succeeded") {
								window.location.href = response.return_url;
							}
						});

					} else {
						$('.alert').addClass('alert-danger').html('<i class="fa fa-times me-3"></i>'+response.msg).show();
						$('#loader').hide();
					}

				}

				break;

		    default:
		    	return true;
		}
	}

	// fonction principale pour l'envoie et le controle de requêtes ajax
	function xhr_send(path, token, $this) {
		var file = $this.data('xhr');
		if($this.data('type') !== undefined) {
			var type = $this.data('type');
		}
		else {
			var type = null;
		}
		var form = '#'+$this.closest('form').attr('id');

		if(type == 'delete') {
			var id = $this.closest('[data-id]').data('id');

			if(confirm('Voulez-vous supprimer cette ligne ?')) {
				$.post(path+'administration/request/xhr/'+file+'.php', { id: id, token: token }, function(response, statusText, jqXHR) {
					if(response.action == 'success') {

						if(response.callback === true) {
							xhr_success(file, response, $this);
						}
						else {
							if(response.msg != null) {
								toastr.success(response.msg);
							}
							$this.closest('[data-id]').remove()					
						}

						if(response.url != null) {
							if(response.msg != null) {								
								setTimeout(function() {
									if(response.url == 'reload') {
										location.reload();
									}
									else {
										location.href = response.url;
									}
								}, 1500);
							}
							else {
								if(response.url == 'reload') {
									location.reload();
								}
								else {
									location.href = response.url;
								}
							}
						}
					}
					else if(response.action == 'empty') {
						if(response.msg != null) {
							toastr.warning(response.msg);
						}
					}
					else if(response.action == 'token') {
						location.reload();
					}   
					else {
						if(response.msg != null) {
							toastr.error(response.msg);
						}
						$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', debug:true, token: token}, function(response2) {}, 'json');
					}
				}, 'json')
				.always(function(jqXHR) {
				    if(jqXHR.status == 404) {			    	
						$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', token: token}, function(response2) {}, 'json');
				    }
				    else if(jqXHR.status == 500) {			    	
						toastr.error('Request error. Please contact the support');

						$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', token: token}, function(response2) {}, 'json');
				    }
				});
			}
		}
		else {
			var data = $(form).serializeArray();
			data[data.length] = { name: 'token', value: token };

			$('.tinymce').each(function() {
				var currentEditorId = $(this).attr('id');
				var val = tinyMCE.get($(this).attr('id')).getContent();

				for (index = 0; index < data.length; ++index) {
				    if (data[index].name == currentEditorId) {
				        data[index].value = val;
				    }
				}
			});

			xhr_data(file, data, $this);

			$('.input__field--error').removeClass('input__field--error');
			$.post(path+'Connections/request/xhr/'+file+'.php', data, function(response, statusText, jqXHR) {
				if(response.action == 'success') {
					if(response.callback === true) {
						xhr_success(file, response, $this);
					}
					else {
						if(response.msg != null) {
							toastr.success(response.msg);						
						}
					}

					if(response.url != null) {
						if(response.msg != null) {								
							setTimeout(function() {
								if(response.url == 'reload') {
									location.reload();
								}
								else {
									location.href = response.url;
								}
							}, 1500);
						}
						else {
							if(response.url == 'reload') {
								location.reload();
							}
							else {
								location.href = response.url;
							}
						}
					}
				}
				else if(response.action == 'empty') {
					if(response.msg != null) {
						toastr.warning(response.msg);
					}

					$.each(response.fields, function(i, item) {
					    $(form).find('#'+item).addClass('input__field--error');
					});
				}
				else if(response.action == 'token') {
					location.reload();
				}
				else {
					if(response.msg != null) {
						toastr.error(response.msg);
					}

					$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', debug:true, token: token}, function(response2) {}, 'json');
				}

				if(file == 'formation/mdlc-subscription') {
					$('#modal-mdlc-subscription [data-xhr]').html('Envoyer');
					$('#modal-mdlc-subscription [data-xhr]').attr('disabled', false);
				}

			}, 'json')
			.always(function(jqXHR) {
			    if(jqXHR.status == 404) {			    	
					$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', token: token}, function(response2) {}, 'json');
			    }
			    else if(jqXHR.status == 500) {			    	
					toastr.error('Request error. Please contact the support');

					$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', token: token}, function(response2) {}, 'json');
			    }
			});
		}
	}

	// bind un click sur les éléments portant le [data-xhr]
	$(document).on('click', '[data-xhr]', function(e) {
		e.preventDefault();
		var $this = $(this);

		if($this.data('trigger') === undefined) {
			xhr_send(path, token, $this);
		}
	});

	$(document).on('change', '#vat', function(e) {
		var $this = $(this);

		xhr_send(path, token, $this);
	});

	// slider temoignages
	$('.slider-temoignages').slick({
		slidesToShow: 1,
  		slidesToScroll: 1,
  		autoplay: true,
  		autoplaySpeed: 5000,
  		arrows:false,
  		dots:false
	});

	$('.slider-video').slick({
		slidesToShow: 5,
  		slidesToScroll: 1,
  		arrows:true,
  		dots:true,
  		infinite: true,
	});

	// payment
	if ($('#card-number').length > 0) {
		console.log('stripe');

		var publicKey = 'pk_test_51MUoYgCEbqQDvtxGBagG6RYaxsw3wEt1FzOXtdRhCwGO0u3QywNKag6ViJMhkdfzIq6BXQS0bM3OargqVSZafPXu00EMAdRann';	

		var stripe = Stripe(publicKey);
		var elements = stripe.elements();

		var cardNumber = elements.create('cardNumber');
		cardNumber.mount('#card-number');
		var cardExpiry = elements.create('cardExpiry');
		cardExpiry.mount('#card-expiry');
		var cardCvc = elements.create('cardCvc');
		cardCvc.mount('#card-cvc');

		// Handle real-time validation errors from the card Element.
		function displayErrors(elem) {
			elem.addEventListener('change', function(event) {
				// var displayError = document.getElementById('card-errors');
				if (event.error) {
					toastr.error(event.error.message)
					// displayError.classList.add("alert", "alert-danger");
					// displayError.textContent = event.error.message;
				} else {
					// displayError.classList.remove("alert", "alert-danger");
					// displayError.textContent = '';
				}
			});
		}
		displayErrors(cardNumber);
		displayErrors(cardExpiry);
		displayErrors(cardCvc);

		function submit_stripe() {
			// Handle form submission.
			// var submit = document.getElementById('stripe_form');

			// submit.addEventListener('submit', function(e) {
			// 	e.preventDefault();

			$('#loader').show();

			$('.alert').removeClass('alert-success alert-danger').html('').hide();

			if ($('input[value=Bancontact]:checked')) {
				var data = $('.bancontact_pay form').serializeArray();
			}
			else {
				var data = $('#stripe_form').serializeArray();
			}
			
			data.push(
				{ name: 'token', value: $('html').attr('token') },
				{ name: 'amount', value: $('.gift_amount span').first().text() }
				);

			$.post('/Connections/request/xhr/stripe/create_intent.php', data, function(response) {

				if (response.pay_type == "bancontact") {
					location.href = response.return_url;
				}
				else {

					if (response.action == 'success') {

						var clientSecret = response.client_secret;

						stripe.confirmCardPayment(clientSecret, {
							payment_method: {
								card: cardNumber,
								billing_details: {
									name: response.name,
								}
							}
						})
						.then(function(result) {
							if (result.error) {
								$('.alert').addClass('alert-danger').html('<i class="fa fa-times me-3"></i>'+result.error.message).show();
								$('#loader').hide();
							}
							else if (result.paymentIntent.status == "succeeded") {
								window.location.href = response.return_url;
							}
						});

					} else {
						$('.alert').addClass('alert-danger').html('<i class="fa fa-times me-3"></i>'+response.msg).show();
						$('#loader').hide();
					}

				}

			}, 'json');

		// });

		}
	}

	// formulaire de contact
	$(document).on('submit', '#form-contact', function(e) {	
		var data = $(this).find('input, textarea, select').filter(':visible, input[type=hidden]').serializeArray();

		$.getJSON(path+'Connections/request/xhr/contact/send-contact.php', data, function(response) {
			if(response.action == 'success') {

				toastr.success(response.msg);
				$('#alert').html('<div class="alert alert-success" role="alert">Message successfully sent !</div>');
				$('input, textarea, select').each(function(){
				    $(this).val('');
				    $('input[type=checkbox]').prop('checked', false);
				});
				
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	// update des données du user
	$(document).on('submit', '#form-user-data', function(e) {
		var data = $(this).serializeArray();

		$.getJSON(path+'Connections/request/xhr/membre/update-user-data.php', data, function(response) {
			if(response.action == 'success') {
				toastr.success(response.msg);
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	// recovery du mot de passe
	$(document).on('submit', '#form-recovery', function(e) {
		var data = $(this).serializeArray();

		$.post(path+'Connections/request/xhr/membre/recovery.php', data, function(response) {
			response = JSON.parse(response);
			if(response.action == 'success') {
				
				if(response.to_redirect == 1){
					toastr.success(response.msg);
					setTimeout(function() {
						location.href = response.url;
					}, 1500);
					
				}else{
					$('#form-recovery').html('Votre demande de récupération de mot de passe a bien été prise en compte. Veuillez suivre le lien qui vous a été envoyé par email. Pensez à vérifier vos spams si vous ne trouvez pas l\'email.');
				}
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	$(document).on('keyup', '#form-new-account input[name=password]', function() {
		var password = $('#form-new-account input[name=password]').val();
		check_pw('#form-new-account input[name=password]');			
	});

	$(document).on('keyup', '#form-recovery input[name=password]', function() {
		var password = $('#form-recovery input[name=password]').val();
		check_pw('#form-recovery input[name=password]');			
	});

	$(document).on('keyup', '#form-update-password input[name=password], #form-update-password input[name=repassword]', function() {
		var password = $('#form-update-password input[name=password]').val();
		var repassword = $('#form-update-password input[name=repassword]').val();
		check_pw('#form-update-password input[name=password]');

		if($(this).closest('form').hasClass('valid') && password == repassword) {
			$(this).closest('form').find('input[type=submit]').prop('disabled', false);
		}
		else {
			$(this).closest('form').find('input[type=submit]').prop('disabled', true);
		}
			
	});

	$(document).on('keyup', '#form-password input[name=password], #form-password input[name=repassword]', function() {
		var password = $('#form-password input[name=password]').val();
		var repassword = $('#form-password input[name=repassword]').val();
		check_pw('#form-password input[name=password]');

		if($(this).closest('form').hasClass('valid') && password == repassword) {
			$(this).closest('form').find('input[type=submit]').prop('disabled', false);
		}
		else {
			$(this).closest('form').find('input[type=submit]').prop('disabled', true);
		}
			
	});

	$(document).on('keyup', '#form-login-not-membre input[name=password], #form-login-not-membre input[name=confirmPassword]', function() {
		var password = $('#form-login-not-membre input[name=password]').val();
		var repassword = $('#form-login-not-membre input[name=confirmPassword]').val();
		check_pw('#form-login-not-membre input[name=password]');
		console.log($(this).closest('form').hasClass('valid'));
		console.log(password == repassword);
		if($(this).closest('form').hasClass('valid') && password == repassword) {
			$(this).closest('form').find('button[type=submit]').prop('disabled', false);
		}
		else {
			$(this).closest('form').find('button[type=submit]').prop('disabled', true);
		}
			
	});

	// recovery du mot de passe
	$(document).on('submit', '#form-password', function(e) {
		var data = $(this).serializeArray();

		$.getJSON(path+'Connections/request/xhr/membre/password.php', data, function(response) {
			if(response.action == 'success') {
				toastr.success(response.msg);
				location.href = response.url;
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	// modification du mot de passe
	$(document).on('submit', '#form-update-password', function(e) {
		var data = $(this).serializeArray();

		$.getJSON(path+'Connections/request/xhr/membre/update-password.php', data, function(response) {
			if(response.action == 'success') {
				toastr.success(response.msg);

				$('input[type=password]').each(function(){
				    $(this).val('');
				});

				$('ul.list-styled li').removeClass('valid-regex');
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	// newsletter
	$(document).on('submit', '#form-newsletter', function(e) {
		var data = $(this).serializeArray();
		data[data.length] = { name: 'token', value: token };

		var $this = $(this);

        $('.input__field--error').removeClass('input__field--error');
		$.post(path+'Connections/request/xhr/contact/newsletter.php', data, function(response) {
			if(response.action == 'success') {
				toastr.success(response.msg);
			    
			    $.get(path+'Connections/request/xhr/contact/newsletter-success.php', function(response2) {
			    	$this.before(response2);
			    	$this.remove();
			    });			    
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);
				$this.find('i').addClass('d-none');
				$.each(response.fields, function(i, item) {
				    $this.find('#'+item).addClass('input__field--error');
				});
			}
			else {
				toastr.error(response.msg);
			}
		}, 'json');

		e.preventDefault();
		return false;
	});

	// contact form
	$(document).on('submit', '#form-contact', function(e) {
		var data = $(this).find('input, textarea, select').filter(':visible, input[type=hidden]').serializeArray();
		data[data.length] = { name: 'token', value: token };

		var $this = $(this);
		$(this).find('i').removeClass('d-none');

        $('.input__field--error').removeClass('input__field--error');
		$.post(path+'Connections/request/xhr/contact/contact.php', data, function(response) {
			if(response.action == 'success') {		
			    toastr.success(response.msg);

			    $.get(path+'Connections/request/xhr/contact/contact-success.php', function(response2) {
			    	$this.before(response2);
			    	$this.remove();
			    });			    
			}
			else if(response.action == 'empty') {	
			    toastr.warning(response.msg);
				$this.find('i').addClass('d-none');
				$.each(response.fields, function(i, item) {
				    $this.find('#'+item).addClass('input__field--error');
				});
			}
			else {	
			    toastr.error(response.msg);				
			}
		}, 'json'); 

		e.preventDefault();
		return false;
	});

	// form formation sur mesure
	$(document).on('submit', '#form-formation-sur-mesure', function(e) {
		var data = $(this).find('input, textarea, select').filter(':visible, input[type=hidden]').serializeArray();
		data[data.length] = { name: 'token', value: token };

		var $this = $(this);
		$(this).find('i').removeClass('d-none');

        $('.input__field--error').removeClass('input__field--error');
		$.post(path+'Connections/request/xhr/contact/formation-sur-mesure.php', data, function(response) {
			if(response.action == 'success') {	
			    toastr.success(response.msg);
			    
			    $.get(path+'Connections/request/xhr/contact/formation-sur-mesure-success.php', function(response2) {
			    	$this.before(response2);
			    	$this.remove();
			    });			    
			}
			else if(response.action == 'empty') {	
			    toastr.warning(response.msg);
				$this.find('i').addClass('d-none');
				$.each(response.fields, function(i, item) {
				    $this.find('#'+item).addClass('input__field--error');
				});
			}
			else {	
			    toastr.error(response.msg);				
			}
		}, 'json'); 

		e.preventDefault();
		return false;
	});

	function pagination(page_size = 10, start = null){
        //Pagination
        //pageSize = 10;
        pageSize = page_size;
        incremSlide = 8;
        startPage = 0;
        numberPage = 1;
        $('.pagination').html('');
        var pageCount =  $(".filter-me").length / pageSize;
        
        if($('.filter-me').length == 0){
            $('.alert').addClass('alert-danger');
            $('.alert').html('<i class="fa fa-times fa-fw"></i> Désolé, aucun résultat n\'a été trouvé');
            $('.alert').show();
        }else{
            $('.alert').removeClass('alert-danger');
            $('.alert').html('');
            $('.alert').hide();
        }
        //var totalSlidepPage = Math.floor(pageCount / incremSlide);
        var totalSlidepPage = Math.ceil(pageCount);
        for(var i = 0 ; i<pageCount;i++){
            var active_class = '';
            
            /*if(i+1 == start) {
            	active_class = 'active';
            }
            else */if(i == 0 && start == null){
                active_class = 'active';
            }
            $(".pagination").append('<li id="pag'+(i+1)+'" class="page-item '+active_class+'"><a class="page-link" style="cursor:pointer;">'+(i+1)+'</a></li> ');
            if(i>pageSize){
                $(".pagination li").eq(i).hide();
            }
        }
        $(".pagination li").hide();
        for(t=startPage;t<incremSlide;t++){
            $(".pagination li").eq(t).show();
        }
        /*if(totalSlidepPage > 1){*/
            var prev = $('<li class="page-item prev"><a class="page-link" style="cursor:pointer;" aria-label="Prev"><span aria-hidden="true"><i class="fas fa-chevron-left"></i></span></a><li>').click(function(){
                startPage-=1;
                incremSlide-=1;
                numberPage--;
                slide();
            });
            prev.hide();
            var next = $('<li class="page-item next"><a class="page-link" style="cursor:pointer;" aria-label="Next"><span aria-hidden="true"><i class="fas fa-chevron-right"></i></span></a><li>').click(function(){
                startPage+=1;
                incremSlide+=1;
                numberPage++;
                slide();
            });
            $(".pagination").prepend(prev).append(next);
        /*}*/
        $(".pagination li").first().find("a").addClass("current");
        slide = function(sens){
            $(".pagination li").hide();
            for(t=startPage-2;t<incremSlide;t++){
                $(".pagination li").eq(t+1).show();
            }
            if(numberPage == 1){
                next.show();
                prev.hide();
            }else if(numberPage == totalSlidepPage ){
                next.hide();
                prev.show();
            }else{
                next.show();
                prev.show();
            }
            $('#pag'+numberPage).addClass('active');
            $('#pag'+numberPage).find('a').addClass('current');
            showPage(numberPage);
        }
        showPage = function(page) {
            $(".filter-me").hide();
            $(".filter-me").each(function(n) {
                if (n >= pageSize * (page - 1) && n < pageSize * page)
                    $(this).show();
            });        
        }
        showPage(1);
        $(".pagination li a").eq(0).addClass("current");
        $(".pagination li a").eq(0).parent().addClass("active");
        $(".pagination li a").click(function() {
            $(".pagination li a").removeClass("current");
            $(".pagination li a").parent().removeClass("active");
            $(this).addClass("current");
            $(this).parent().addClass("active");
            showPage(parseInt($(this).text()));
            if($.isNumeric(parseInt($(this).text()))){
                numberPage = parseInt($(this).text());
                if(numberPage == 1){
                    next.show();
                    prev.hide();
                }else if(numberPage == totalSlidepPage ){
                    next.hide();
                    prev.show();
                }else{
                    next.show();
                    prev.show();
                }
            }
        });

        if(start != null) {

        	$(".pagination li a").removeClass("current");
            $(".pagination li a").parent().removeClass("active");
            // $(this).addClass("current");
            $('#pag'+start).addClass("active");
        	showPage(start);
            if($.isNumeric(start)){
                numberPage = start;
                if(numberPage == 1){
                    next.show();
                    prev.hide();
                }else if(numberPage == totalSlidepPage ){
                    next.hide();
                    prev.show();
                }else{
                    next.show();
                    prev.show();
                }
            }
        }
        
    }

	var xhr;
    function search_recrutement(path) {
		var filter = [];
		var search = $('#search-job').val();
		var page = $('#paginations .page-item.active').attr('id');
		if (page === undefined) {
			page = 1;
		}

		$('input[data-cat]:checked').each(function(i) {
            filter.push($(this).data('cat'));
    	});

    	if(xhr && xhr.readyState != 4){
            xhr.abort();
        }

		xhr = $.post(path+'Connections/request/xhr/recrutement/filter.php', { filter: filter, search: search, page: page, token: token}, function(response) {
			if(response.action == 'success') {	
			    $('[data-job]').hide();
			    $('[data-job]').removeClass('filter-me');
				$.each(response.job, function(i, item) {					    
			    	$('[data-job="'+item+'"]').addClass('filter-me');
				});

				pagination(10);
			   	    
			}
			else if(response.action == 'empty') {	
			    toastr.warning(response.msg);
			}
			else {	
			    toastr.error(response.msg);				
			}
		}, 'json'); 
    }

    if($('#recrutement')) {
    	var nbr_job_page = 10;

    	pagination(nbr_job_page);

    	if (sessionStorage.getItem('job-page')) {
    		pagination(nbr_job_page, sessionStorage.getItem('job-page'));
    		sessionStorage.removeItem('job-page');
    	}
    	else {
    		pagination(nbr_job_page);
    	}

    	$(document).on('click', 'input[data-cat]', function(e) {
    		search_recrutement(path);
    	});

    	$(document).on('keyup', '#search-job', function(e) {
    		search_recrutement(path);
    	});

    	$(document).on('click', '.job-details', function(e) {
    		e.preventDefault();	
			
			var $this = $(this);
			var filter = [];
			var search = $('#search-job').val();
			var page = $('#paginations .page-item.active').attr('id');

			$('input[data-cat]:checked').each(function(i) {
	            filter.push($(this).data('cat'));
	    	});

    		$.post(path+'Connections/request/xhr/recrutement/filter.php', { filter: filter, search: search, page: page, token: token}, function(response) {
				if(response.action == 'success') {
    				location.href = $this.attr('href');				   	    
				}
				else if(response.action == 'empty') {	
				    toastr.warning(response.msg);
				}
				else {	
				    toastr.error(response.msg);				
				}
    		}, 'json');
    	});

    	$(document).on('click', '[data-page]', function(e) {
    		e.preventDefault();

    		var page = $(this).data('page');

    		sessionStorage.setItem('job-page', page);
    		location.href = $(this).attr('href');
		});	

    }

    function search_training(path) {
		var filter = [];
		var cat = [];
		var search = $('#search-training').val();
		var page = $('#paginations .page-item.active').attr('id');
		if (page === undefined) {
			page = 1;
		}

		$('input[data-cat]:checked').each(function(i) {
            filter.push($(this).val());
            cat.push($(this).data('cat'));
    	});

    	var duree = $('#duree-hour').val();
    	var range = $('#ipi-hour').val();

    	if(xhr && xhr.readyState != 4){
            xhr.abort();
        }

		xhr = $.post(path+'Connections/request/xhr/formation/filter.php', { filter: filter, cat: cat, duree: duree, range: range, search: search, page: page, token: token }, function(response) {
			if(response.action == 'success') {	
			    $('[data-training]').hide();
			    $('[data-training]').removeClass('filter-me');
				$.each(response.training, function(i, item) {					    
			    	$('[data-training="'+item+'"]').addClass('filter-me');
				});

				pagination(10);
			   	    
			}
			else if(response.action == 'empty') {	
			    toastr.warning(response.msg);
			}
			else {	
			    toastr.error(response.msg);				
			}
		}, 'json'); 
    }

    if($('#training')) {
    	var nbr_training_page = 10;

    	pagination(nbr_training_page);
    	
    	if (sessionStorage.getItem('training-page')) {
    		pagination(nbr_training_page, sessionStorage.getItem('training-page'));

			var scrollto = $('[data-training="'+sessionStorage.getItem('training-id')+'"]').offset().top;

			$("body, html").animate({
				scrollTop: scrollto
			}, 100 );

    		sessionStorage.removeItem('training-page');
    		sessionStorage.removeItem('training-id');
    	}
    	else {
    		pagination(nbr_training_page);
    	}

    	$(document).on('click', 'input[data-cat]', function(e) {
    		search_training(path);
    	});

    	$(document).on('keyup', '#training #search-training', function(e) {
    		search_training(path);
    	});

    	$(document).on('click', '.training-details', function(e) {
    		e.preventDefault();	
			
			var $this = $(this);
			var filter = [];
			var cat = [];
			var search = $('#search-training').val();
			var page = $('#paginations .page-item.active').attr('id');	
			if (page === undefined) {
				page = 1;
			}		

			$('input[data-cat]:checked').each(function(i) {
	            filter.push($(this).val());
	            cat.push($(this).data('cat'));
	    	});

    		var duree = $('#duree-hour').val();
    		var range = $('#ipi-hour').val();

    		$.post(path+'Connections/request/xhr/formation/filter.php', { filter: filter, cat: cat, duree: duree, range: range, search: search, page: page, token: token }, function(response) {
				if(response.action == 'success') {
    				location.href = $this.attr('href');				   	    
				}
				else if(response.action == 'empty') {	
				    toastr.warning(response.msg);
				}
				else {	
				    toastr.error(response.msg);				
				}
    		}, 'json');
    	});

    	$(document).on('click', '[data-page]', function(e) {
    		e.preventDefault();

    		var page = $(this).data('page');
    		var id = $(this).data('training-id');

    		sessionStorage.setItem('training-page', page);
    		sessionStorage.setItem('training-id', id);
    		location.href = $(this).attr('href');
		});	

    }

	// filter CLL vs E-learning
	$(document).on('click', '#modalite-cll, #type-2', function() {
		console.log($(this).is(':checked'));
		if($(this).is(':checked')) {
			$('#modalite-cll, #type-2').prop('checked', true);
		}
		else {
			$('#modalite-cll, #type-2').prop('checked', false);
		}

		search_training(path);

	});

	if($('#ipi-hour').length >0) {
		var duree_hour = $('#duree-hour');
		duree_hour.ionRangeSlider({
	        skin: 'round',
	        grid: false,
	        prettify_enabled: false
	    });

	    var duree_hour_data = duree_hour.data("ionRangeSlider");

	    duree_hour.on("change", function () {
	        var range = $(this).val().split(';'); // reading input value
	        var min = $(this).data("min");
	        var max = $(this).data("max");

	        search_training(path);	        
	    });	

		var ipi_hour = $('#ipi-hour');
		ipi_hour.ionRangeSlider({
	        skin: 'round',
	        grid: false,
	        prettify_enabled: false
	    });

	    var ipi_hour_data = ipi_hour.data("ionRangeSlider");

	    ipi_hour.on("change", function () {
	        var range = $(this).val().split(';'); // reading input value
	        var min = $(this).data("min");
	        var max = $(this).data("max");

	        search_training(path);	        
	    });	
	}

	$(document).on('click', '.modal-subscription-btn', function(e) {
		e.preventDefault();

		if($(this).closest('[data-id]').data('id') == undefined) {
			var id = 'tmp';
		}
		else {
			var id = $(this).closest('[data-id]').data('id');
		}

		$('#modal-subscription #session').val(id);
		// $('#modal-subscription #ipi-number').closest('.row').addClass('d-none');

		$('#modal-subscription').modal('show');
	});

	$(document).on('click', '#modal-subscription #ipi', function(e) {

		if($(this).is(':checked')) {
			$('#modal-subscription #ipi-number').closest('.row').removeClass('d-none');
		}
		else {
			$('#modal-subscription #ipi-number').closest('.row').addClass('d-none');
		}
	});

	$(document).on('click', 'form #student', function(e) {

		if($(this).is(':checked')) {
			$(this).closest('form').find('#school').closest('.row').removeClass('d-none');
		}
		else {
			$(this).closest('form').find('#school').closest('.row').addClass('d-none');
		}
	});

	if($('#calendar').length > 0) {
        $.getJSON('/Connections/request/xhr/formation/get-training.php', function(response) {
            var training = response.training;

            $("#calendar").simpleCalendar({

                // displays events
                displayEvent: true,

                // event dates
                events: response.training,

                // disable showing event details
                disableEventDetails: false,

                // disable showing empty date details
                disableEmptyDetails: false,
                months: ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'],
                days: ['Dimanche','Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi'],

            });
        });            
    }

	$(document).on('click', '.preview-video', function (e) {
		e.preventDefault();
		var href = $(this).attr('href');
		var title = $(this).closest('.card').find('.video-title').html();
		$('#modal-preview-video').find('source').attr('src', href+ '?autoplay=1&amp;modestbranding=1&amp;showinfo=0');
		$('#video-preview')[0].load();
		$('#modal-preview-video').modal('show');
		$('#modal-preview-video .modal-title').html(title);
		$('#video-preview')[0].play();
		$('#video-preview').prop('muted', false);
	});

	$('#modal-preview-video').on('hidden.bs.modal', function () {
		$('#video-preview')[0].pause();
		$('#modal-preview-video .modal-title').html('aa');
	});

	$(document).on('click', '[data-payment-method]', function(e) {
		var method = $(this).data('payment-method');
		$('#payment-method').val(method);

		$('[data-payment-method]').removeClass('active');
		$(this).addClass('active');

		if(method == 'credit-card') {
			$('#credit-card-box').removeClass('d-none');
		}
		else {
			$('#credit-card-box').addClass('d-none');
		}
	});

	if($('#payment-waiting').length > 0) {
		var order = $('[data-order]').data('order');

		function checkPayment(token, order) {
			$.getJSON(path+'Connections/request/xhr/cart/check-payment.php', { token: token, order: order }, function(response) {
				if(response.action == 'success') {

					if(response.status == 'succeeded' || response.status == 'failed') {
						$('.payment-status').addClass('d-none');
						$('#payment-'+response.status).removeClass('d-none');
						clearInterval(interval);
					}			
				}
			});
		}

		checkPayment(token, order);
		var interval = setInterval(checkPayment, 2000, token, order); 
	}

    
    // CASE INSENSITIVE FUNCTION.
	jQuery.expr[':'].contains = function(a, i, m) {
    var rExps=[
        {re: /[\xC0-\xC6]/g, ch: "A"},
        {re: /[\xE0-\xE6]/g, ch: "a"},
        {re: /[\xC8-\xCB]/g, ch: "E"},
        {re: /[\xE8-\xEB]/g, ch: "e"},
        {re: /[\xCC-\xCF]/g, ch: "I"},
        {re: /[\xEC-\xEF]/g, ch: "i"},
        {re: /[\xD2-\xD6]/g, ch: "O"},
        {re: /[\xF2-\xF6]/g, ch: "o"},
        {re: /[\xD9-\xDC]/g, ch: "U"},
        {re: /[\xF9-\xFC]/g, ch: "u"},
        {re: /[\xC7-\xE7]/g, ch: "c"},
        {re: /[\xD1]/g, ch: "N"},
        {re: /[\xF1]/g, ch: "n"}
    ];

    var element = $(a).text();
    var search  = m[3];

    $.each(rExps, function() {
         element    = element.replace(this.re, this.ch);
         search     = search.replace(this.re, this.ch);
    });

    return element.toUpperCase()
        .indexOf(search.toUpperCase()) >= 0;
    };
});

function check_pw(password) {
	var $this = $(password);
	var pw = $this.val();
	var test = true;
	// At least one LOWERCASE character:
	var lowerCasePattern = /^(?=.*[a-z]).+$/;

	if(lowerCasePattern.test(pw)) {		    
		$('.lowercase').addClass('valid-regex');
	}
	else {
		$('.lowercase').removeClass('valid-regex');
		test = false;
	}

    // At least one UPPERCASE character:
    var upperCasePattern = /^(?=.*[A-Z]).+$/;
    
    if(upperCasePattern.test(pw)) {		    
    	$('.uppercase').addClass('valid-regex');
    }
    else {
    	$('.uppercase').removeClass('valid-regex');
    	test = false;
    }

    // At least one NUMBER:
    var numberPattern = /^(?=.*[\d]).+$/;
    
    if(numberPattern.test(pw)) {		    
    	$('.number').addClass('valid-regex');
    }
    else {
    	$('.number').removeClass('valid-regex');
    	test = false;
    }

    // At least one SPECIAL character:
    var specialCharacterPattern = /([-+=_!@#$%^&*.,;:'\"<>/?`~\[\]\(\)\{\}\\\|\s])/;

    if(specialCharacterPattern.test(pw)) {		    
    	$('.specialcase').addClass('valid-regex');
    }
    else {
    	$('.specialcase').removeClass('valid-regex');
    	test = false;
    }

    // At least 8 characters in the screen:
    var characterCountPattern = /^.{8,}/;

    if(characterCountPattern.test(pw)) {		    
    	$('.minimumcase').addClass('valid-regex');
    }
    else {
    	$('.minimumcase').removeClass('valid-regex');
    	test = false;
    }

    if($('.not-secure li').length == $('.valid-regex').length) {
    	$this.closest('form').addClass('valid');
    }
    else {
    	$this.closest('form').removeClass('valid');
    }
}

